'use strict'

import css from './create.styles.scss'
import template from './create.template.pug'

class CreateReportController {
  constructor($mdDialog, $mdToast) {
    'ngInject'
    Object.assign(this, { $mdDialog, $mdToast }, {})
  }

  cancel() {
    this.$mdDialog.cancel()
  }

  save() {
    this.customer
      .createReport({
        parameters: this.parameters,
        code: this.reportType.code,
      })
      .then(() => {
        this.handleSuccess('Report wurde erfolgreich erstellt')
      })
      .catch((error) => {
        this.handleError(error.data.message)
      })
  }

  handleSuccess(msg) {
    this.$mdDialog.hide()
    const toast = this.$mdToast.simple().textContent(msg).action('OK').position('bottom').hideDelay(10000)
    this.$mdToast.show(toast)
  }

  handleError() {
    // TODO handle errors
  }

  select(type) {
    this.reportType = type
    this.tabIdx = 1
  }

  toggleTabs() {
    this.tabIdx ^= 1
  }
}

export const createReportComponent = {
  controller: CreateReportController,
  controllerAs: '$ctrl',
  clickOutsideToClose: false,
  escapeToClose: true,
  template: template({ css }),
  fullscreen: true,
  bindToController: true,
}

export const createReportConfig = ($mdDialogProvider) => {
  'ngInject'

  $mdDialogProvider.addPreset('createReportDialog', {
    options: () => {
      return createReportComponent
    },
  })
}



// WEBPACK FOOTER //
// ./app/reports/containers/create/create.component.js